import { Outlet, useNavigate } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { hasRegularAccessOrNotEmployee } from 'modules/employees/lib/utils'
import { useHasShiftManagement } from 'modules/shift_management/hooks/useHasShiftManagement'
import ShiftManagementMainPage from 'modules/shift_management/pages/ShiftManagementMainPage'

const MainPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { loading, canUseShiftManagement } = useHasShiftManagement()
  const { employee } = useCurrentSession()

  const { loading: loadingContractVersions } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  if (!loading && canUseShiftManagement && !hasRegularAccessOrNotEmployee(employee)) {
    navigate(navigation.profile.fullPath())

    return null
  }

  if (!loading && !canUseShiftManagement) {
    navigate(navigation.dashboard.fullPath())

    return null
  }

  if (loading || loadingContractVersions) {
    return <Loading />
  }

  return (
    <ShiftManagementMainPage contractVersions={contractVersions}>
      <Outlet />
    </ShiftManagementMainPage>
  )
}

export default MainPage
